import { center, text, vstack } from '@onbeam/business-styled-system/patterns';
import { BountyDrawerContentProps } from './BountyDrawerContent.types';
import { DrawerField } from '@/components/shared/DrawerField';
import Image from 'next/image';
import { css } from '@onbeam/business-styled-system/css';
import { Button } from '@onbeam/business-ui';
import NextLink from 'next/link';
import { MarkdownRenderer } from '@/components/shared/MarkdownRenderer';
import { applicationStyleMap } from '@/components/features/Applications/ApplicationsList/ApplicationsList.data';

export const BountyDrawerContent = ({
  id,
  name,
  category,
  reward,
  whatWeWant,
  whyThisMatters,
  whatWeExpect,
  whoCanApply,
  whatYouGet,
}: BountyDrawerContentProps) => {
  const style = applicationStyleMap[category];
  const Icon = style.icon;

  return (
    <div className={vstack({ gap: '6', mb: '20' })}>
      <div
        className={center({
          mt: '-20',
          mx: '-8',
          w: '[calc(100% + token(spacing.16))]',
          position: 'relative',
          overflow: 'hidden',
          h: '[10.5rem]',
        })}
      >
        <Image
          priority
          className={css({
            position: 'absolute',
            inset: '0',
            objectFit: 'cover',
            w: 'full',
            h: 'full',
          })}
          width={430}
          height={168}
          src={style.bgImageUrl}
          alt=""
        />
        <div
          className={center({
            p: '4',
            rounded: '[1rem]',
            border: '1px solid',
            borderColor: 'opacity.sm',
            bg: 'mono.primaryFg',
            zIndex: '5',
          })}
        >
          <Icon height={32} width={32} />
        </div>
      </div>
      <div className={vstack({ gap: '10' })}>
        <div className={vstack({ gap: '1' })}>
          <span>{name}</span>
          <span className={text({ style: 'body-md' })}>
            <span className={text({ color: 'mono.tertiary' })}>Reward:</span>{' '}
            <span>{reward}</span>
          </span>
        </div>
        <DrawerField
          title="What we want"
          description={<MarkdownRenderer>{whatWeWant}</MarkdownRenderer>}
        />
        <DrawerField
          title="Why this matters"
          description={<MarkdownRenderer>{whyThisMatters}</MarkdownRenderer>}
        />
        <DrawerField
          title="What we expect from you"
          description={<MarkdownRenderer>{whatWeExpect}</MarkdownRenderer>}
        />
        <DrawerField
          title="Who can apply"
          description={<MarkdownRenderer>{whoCanApply}</MarkdownRenderer>}
        />
        <DrawerField
          title="What you get"
          description={<MarkdownRenderer>{whatYouGet}</MarkdownRenderer>}
        />
      </div>
      <div
        className={css({
          position: 'absolute',
          bottom: '0',
          insetX: '0',
          px: '8',
          py: '4',
          bg: 'mono.primaryFg',
          borderTop: '1px solid',
          borderColor: 'opacity.sm',
        })}
      >
        <Button as={NextLink} href={`/apply/${id}`} size="fullWidth">
          Submit proposal
        </Button>
      </div>
    </div>
  );
};
